export function makeDragGhost(
    e: DragEvent,
    opts: { label: string; iconSrc?: string; offsetX?: number; offsetY?: number }
) {
    const { label, iconSrc, offsetX = 12, offsetY = 16 } = opts;

    const ghost = document.createElement("div");
    ghost.style.cssText = `
    position:absolute; top:-9999px; left:-9999px;
    display:inline-flex; align-items:center; gap:6px;
    padding:6px 10px; border-radius:8px;
    background:rgba(79,70,229,.92); color:#fff;
    font:500 12px system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial;
    box-shadow:0 6px 18px rgba(0,0,0,.25);
    pointer-events:none;
  `;

    if (iconSrc) {
        const img = document.createElement("img");
        img.src = iconSrc;
        img.height = 14;
        img.alt = "";
        ghost.appendChild(img);
    }

    const span = document.createElement("span");
    span.textContent = label;
    ghost.appendChild(span);

    document.body.appendChild(ghost);
    e.dataTransfer?.setDragImage(ghost, offsetX, offsetY);

    // return cleanup
    return () => { if (ghost.parentNode) ghost.parentNode.removeChild(ghost); };
}
